import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/flightPreferences', request)
}

export {get}
